import { useContext } from 'react';
import { SearchStyle, Context as ConfigContext } from '../../Config';
import { useSearchWithResultsPage } from './useSearchWithResultsPage';
import { useSearchWithDropdown } from './useSearchWithDropdown';
/**
 * A hook that gives you access to all the functionality required to perform searches in an Elevio Knowledge Base.
 *
 * An initial example of the usage of this is provided in the starter kits, it is recommend you customise your feedback components from that base rather than try to understand everything this hook does.
 *
 * The [Search Component](https://www.notion.so/Search-729bd43814714ee196e9c0be40e6f376) already has all of the functionality listed below and may sufficient for your needs.
 *
 * Usage example:
 * ```javascript
 * import { useSearch } from "@elevio/kb-kit/lib/hooks";
 *
 * export const MyHookSearch = () => {
 *   const {
 *     isOpen,
 *     onChange,
 *     onCloseDropdown,
 *     onKeyUp,
 *     onOpenDropdown,
 *     onReset,
 *     onSubmit,
 *     searchStyle,
 *     value,
 *   } = useSearch();
 *
 *   return (
 *     <div>
 *       <input
 *         type="search"
 *         value={value}
 *         onChange={onChange}
 *         onFocus={onOpenDropdown}
 *         onKeyUp={onKeyUp}
 *         onBlur={onCloseDropdown}
 *       />
 *       <button onClick={onSubmit}>Submit</button>
 *       <button onClick={onReset}>Reset</button>
 *       <p>{isOpen ? "It's open!" : "It's closed!"}</p>
 *       <p>The search style is: {searchStyle}</p>
 *     </div>
 *   );
 * };
 * ```
 */
export function useSearch() {
    const { searchStyle = SearchStyle.resultsPage } = useContext(ConfigContext);
    // eslint disable because Config won't ever change, so we won't ever change the hook we are returning.
    if (searchStyle !== SearchStyle.resultsPage)
        return useSearchWithDropdown(); // eslint-disable-line react-hooks/rules-of-hooks
    return useSearchWithResultsPage(); // eslint-disable-line react-hooks/rules-of-hooks
}
//# sourceMappingURL=index.js.map